/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/url/IsHttpsUrl.ts
 * @create:      2025-06-28 09:10:09.547
 * @modify:      2025-07-11 21:19:12.800
 * @version:     6.0.0
 * @times:       5
 * @lines:       57
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Determines whether a given URL string uses the HTTPS protocol.
 *
 * @param url - The URL string to check.
 * @returns
 * - `true` if the URL starts with "https://" or is protocol-relative ("//").
 * - `false` if the URL starts with "http://".
 * - `undefined` if the URL does not start with either "http://", "https://", or "//".
 * 
 * @since 2.0.6
 * @version 2021-12-11
 */
export function IsHttpsUrl(url: string) {
    const urlLowerCase = url.toLowerCase();
    if (urlLowerCase.startsWith("https://") || urlLowerCase.startsWith("//")) {
        return true;
    }

    if (urlLowerCase.startsWith("http://")) {
        return false;
    }

    return undefined;
}
